<template>
    <div>
        <img src="@/assets/images/top.jpg" alt="banner" class="img_s">
    </div>
</template>
<script>

export default{
    name:'Header',
    data () {
        return {
            msg:'success'
        }
    }
}
</script>
<style scoped>
.img_s{width:100%;display: block;}
div h2 { text-align: center;}
</style>


// WEBPACK FOOTER //
// src/components/public/Header.vue